angular.module('elfium').constant('BUSINESS_CASE_REQUIRED_FIELDS', {
    nazev: 'název',
    firmaId: 'firma',
    userId: 'konzultant',
    kontaktId: 'osoba',
    divize: 'divize'
}).constant('BUSINESS_CASE_FIELD_TYPES', {
	BOOLEAN: ['priorita'],
	DATE: []
}).constant('BUSINESS_CASE_STATES', {
	WIN: 'W',
	LOST: 'L',
	ACTIVE: 'A',
	NICE_TO_HAVE: 'N'
});


// WEBPACK FOOTER //
// ./src/app/components/businessCase/businessCaseConstants.ts